import React from 'react';
import Glider from "./Glider";
import { jsx as _jsx } from "react/jsx-runtime";
export const Carousel = _ref => {
  let {
    itemWidth,
    slidesToShow = 3.2,
    slidesToScroll = 1,
    children
  } = _ref;
  return /*#__PURE__*/_jsx(Glider, {
    draggable: true,
    hasArrows: true,
    scrollLock: true,
    dragVelocity: 1,
    duration: 1,
    slidesToShow: itemWidth ? 'auto' : slidesToShow,
    slidesToScroll: slidesToScroll,
    itemWidth: itemWidth,
    exactWidth: !!itemWidth,
    children: children
  });
};